import { render, staticRenderFns } from "./FilterAgeCertification.vue?vue&type=template&id=86d76040&scoped=true"
import script from "./FilterAgeCertification.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterAgeCertification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterAgeCertification.vue?vue&type=style&index=0&id=86d76040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d76040",
  null
  
)

export default component.exports